// extracted by mini-css-extract-plugin
export default {"divider":"LKxbb8","root":"Udf2Wk","isMobile":"aBwaMl","withoutCommentBox":"gLdmUu","commentBox":"n9rxkh","lockedState":"rQAQRL","withTopMargin":"EK3Ve5","sort":"QasAcq"};